var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/propose-result.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-04ab39d6!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/propose-result.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProposeResult.vue
// module id = 686
// module chunks = 1